import contentfulGql from 'js/lib/contentfulGql';

import { entWebsiteBlockAssemblyFragment } from 'bundles/ent-website/queries/EntWebsiteBlockAssembly';
import { ctaFragment } from 'bundles/ent-website/queries/common';

export const entWebsiteCourseSearchWidgetFragment = contentfulGql`#graphql
  ${ctaFragment}
  fragment EntWebsiteCourseSearchWidget on EntWebsiteCourseSearchWidget {
    headline
    slug
    searchResultMessage
    searchResultCta {
      ...Cta
    }
  }
`;

export const entWebsiteBlockCourseSearchWidgetQuery = contentfulGql`#graphql
  ${entWebsiteBlockAssemblyFragment}
  ${entWebsiteCourseSearchWidgetFragment}
  query entWebsiteBlockCourseSearchWidget($id: String!, $preview: Boolean, $locale: String!) {
    entWebsiteBlockAssembly(id: $id, preview: $preview, locale: $locale) {
      ...EntWebsiteBlockAssembly
      reference {
        __typename
        ...EntWebsiteCourseSearchWidget
      }
    }
  }
`;
